import classNames from 'classnames';

export const NA = (props: { text: string; isBlackColor?: boolean }) => {
  return (
    <div
      className={classNames(
        'cursor-pointer font-font-weight/table-cell-normal text-font-size/table-cell leading-line-height/table-cell',
        {
          'mhg-alpha-btn-text-disabled': !props.isBlackColor,
        },
      )}
    >
      {props.text}
    </div>
  );
};
